/* eslint-disable react/prop-types */
/* eslint-disable promise/always-return */
/* eslint-disable react/no-children-prop */

import moment from 'moment-timezone';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { DownloadReportData, EmailDownloadReportData } from '../../../api/reports';
import { Button, InfoLabel, ModalComponent, RadioInput } from '../../../common/components';
import { useSetLoading } from '../../../common/hooks/appearance';
import {
  downloadTypes,
  downloadTypesTrust,
  fetchDashboardFilterData,
  fetchMultiSelectData,
  reports,
} from '../../../utils/constant';
import * as handlers from '../../../utils/handlers';
import { makeDownloadReady } from '../../../utils/utils';

const DownloadModal = ({
  isOpen,
  toggle,
  reportType,
  urlParams,
  dateRangeDiffGreaterthanYear = false,
  showDownloadPreview,
  onDownloadClick,
  bulkIdsPayload,
  selectAll,
  selectDue,
  bulkIdsPayloadUnSelected,
  willReceiveFileInEmail,
  willReceiveReportFileInEmail,
  module,
  downloadOptions,
  newFilters = false,
}) => {
  const filterData = useSelector((state) =>
    newFilters ? state.filters.dashboardMultiSelectFilters : state.filters.filtersForMultiSelect,
  );
  const defaultFilters = useSelector((state) => state?.filters?.defaultMultiSelectFilters);
  const [exportType, setExportType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);

  const fetchFilterDataForAPI = (data) => {
    if (newFilters) return fetchDashboardFilterData(data);
    return fetchMultiSelectData(data, defaultFilters);
  };

  const filterBulkIds = (bulkIdsPayloadValues) => {
    const onePortalIds = [];
    bulkIdsPayloadValues.forEach((rowData) => {
      if (!onePortalIds.includes(rowData?.onePortalId)) onePortalIds.push(rowData?.onePortalId);
    });
    // Remove Static bulkOnePortalIds definition after BE fixes null check
    return onePortalIds?.length === 0 ? ['Valued'] : onePortalIds;
  };

  const downloadHandler = async () => {
    if (dateRangeDiffGreaterthanYear && exportType === 'PDF') {
      setShowError(true);
    } else {
      try {
        setShowError(false);
        setLoading(true);
        const params = {
          ...urlParams,
          ...(module !== 'Trust' && {
            ...fetchFilterDataForAPI(filterData),
          }),
          ...(bulkIdsPayload && {
            bulkOnePortalIds: filterBulkIds(bulkIdsPayload),
          }),
          ...(selectAll &&
            (!bulkIdsPayload || bulkIdsPayload.length === 0) && {
              notSelectedIds: bulkIdsPayloadUnSelected,
              allSelected: selectAll,
            }),
          ...(selectAll &&
            bulkIdsPayload &&
            bulkIdsPayload.length > 0 && {
              bulkOnePortalIds: filterBulkIds(bulkIdsPayload),
            }),
          ...(selectDue && {
            notSelectedIds: bulkIdsPayloadUnSelected,
            dueSelected: selectDue,
          }),
          exportType: exportType.toLowerCase(),
          timezone: moment.tz.guess(),
        };

        let response;
        if (willReceiveReportFileInEmail) {
          response = await EmailDownloadReportData(reportType, {
            ...params,
          });
        } else {
          response = await DownloadReportData(reportType, params);
        }
        if (response?.status === 200) {
          if (
            (showDownloadPreview && exportType === 'PDF') ||
            willReceiveFileInEmail ||
            willReceiveReportFileInEmail
          ) {
            onDownloadClick(response?.data, exportType, reportType);
            setExportType(null);
          } else {
            makeDownloadReady(response?.data, exportType, reportType);
            setExportType(null);
          }
        } else {
          handlers.apiErrorHandler({ message: 'Network Error' });
        }
        setLoading(false);
        toggle();
      } catch (err) {
        setLoading(false);
        toggle();
        handlers.apiErrorHandler(err);
      }
    }
  };

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  const ModalGenerator = () => {
    return (
      <div
        className="Download-modal"
        style={{
          padding: '30px',
        }}
      >
        <div className="Download-heading">
          <InfoLabel label="Download Report" />
        </div>
        <p className="Download-sub-heading">
          In which format would you like to download the report
        </p>
        <div style={{ display: 'flex', flexDirection: 'column' }} className="Add-email">
          {Object.keys(
            downloadOptions ||
              (module === 'Trust' && reportType !== reports.TRUST_ACCOUNT_DETAILS
                ? downloadTypesTrust
                : downloadTypes),
          ).map((key) => {
            return (
              <React.Fragment key={downloadTypes[key]}>
                <RadioInput
                  formInput={false}
                  name="discountType"
                  label={`Download as ${downloadTypes[key]} Format`}
                  value={downloadTypes[key]}
                  onChange={() => {
                    setExportType(downloadTypes[key]);
                  }}
                />
              </React.Fragment>
            );
          })}
        </div>
        <hr />
        <div className="Download-btn-section">
          {showError && (
            <span className="error-text">
              please select date range with gap less than a year to download the report in pdf
              format
            </span>
          )}
          <Button
            color="primary"
            size="lg"
            style={{ fontSize: '14px' }}
            className="send-btn"
            onClick={downloadHandler}
            disabled={!exportType}
          >
            Download
          </Button>
          <Button
            color="#F3F3F3"
            className="btn-close"
            style={{ fontSize: '14px' }}
            onClick={() => {
              setExportType(null);
              setShowError(false);
              toggle();
            }}
          >
            Close
          </Button>
        </div>
      </div>
    );
  };

  return (
    <ModalComponent isOpen={isOpen} toggle={toggle} className="DownloadModalWrapper">
      {ModalGenerator()}
    </ModalComponent>
  );
};

export default DownloadModal;
